/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type matricesPanelQueryVariables = {
    readonly listID: string;
};
export type matricesPanelQueryResponse = {
    readonly list: {
        readonly hasErrors: boolean | null;
        readonly list: {
            readonly name?: string | null;
            readonly label?: string | null;
            readonly description?: string | null;
            readonly title?: string | null;
            readonly subTitle?: string | null;
            readonly items?: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly listItem: {
                        readonly item: ({
                            readonly description?: string | null;
                            readonly id?: string;
                            readonly label?: string | null;
                            readonly link?: string | null;
                            readonly publisher?: string | null;
                            readonly publishedDate?: unknown | null;
                            readonly previews?: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly link: string | null;
                                        readonly mediaAsset: {
                                            readonly id: string;
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly revision?: string | null;
                            readonly subTitle?: string | null;
                            readonly timeToReadInSeconds?: number | null;
                            readonly title?: string | null;
                            readonly cost?: string | null;
                            readonly area?: string | null;
                            readonly country?: string | null;
                            readonly countryCode?: string | null;
                            readonly durationInSeconds?: number | null;
                            readonly landingPageUrl?: string | null;
                            readonly isPublic?: boolean | null;
                            readonly kind?: string | null;
                            readonly linkUrl?: string | null;
                            readonly location?: string | null;
                            readonly name?: string | null;
                            readonly previewUrl?: string | null;
                            readonly published?: unknown | null;
                            readonly responsibility?: string | null;
                            readonly settlement?: string | null;
                            readonly tagLine?: string | null;
                            readonly tags?: ReadonlyArray<string> | null;
                            readonly hasPublicPage?: boolean | null;
                            readonly websiteUrl?: string | null;
                            readonly timeRequiredInSeconds?: number | null;
                            readonly mediaItem?: {
                                readonly id: string;
                                readonly label: string | null;
                            } | null;
                            readonly fullName?: string | null;
                        } & ({
                            readonly description: string | null;
                            readonly id: string;
                            readonly label: string | null;
                            readonly link: string | null;
                            readonly publisher: string | null;
                            readonly publishedDate: unknown | null;
                            readonly previews: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly link: string | null;
                                        readonly mediaAsset: {
                                            readonly id: string;
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly revision: string | null;
                            readonly subTitle: string | null;
                            readonly timeToReadInSeconds: number | null;
                            readonly title: string | null;
                        } | {
                            readonly cost: string | null;
                        } | {
                            readonly area: string | null;
                            readonly country: string | null;
                            readonly countryCode: string | null;
                            readonly durationInSeconds: number | null;
                            readonly landingPageUrl: string | null;
                            readonly isPublic: boolean | null;
                            readonly kind: string | null;
                            readonly linkUrl: string | null;
                            readonly location: string | null;
                            readonly name: string | null;
                            readonly previewUrl: string | null;
                            readonly published: unknown | null;
                            readonly responsibility: string | null;
                            readonly settlement: string | null;
                            readonly tagLine: string | null;
                            readonly tags: ReadonlyArray<string> | null;
                        } | {
                            readonly hasPublicPage: boolean | null;
                            readonly websiteUrl: string | null;
                        } | {
                            readonly timeRequiredInSeconds: number | null;
                        } | {
                            readonly mediaItem: {
                                readonly id: string;
                                readonly label: string | null;
                            } | null;
                        } | {
                            readonly fullName: string | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
            } | null;
        } | null;
    } | null;
};
export type matricesPanelQuery = {
    readonly response: matricesPanelQueryResponse;
    readonly variables: matricesPanelQueryVariables;
};



/*
query matricesPanelQuery(
  $listID: ID!
) {
  list(id: $listID) {
    hasErrors
    list {
      __typename
      ... on List {
        name
        label
        description
        title
        subTitle
        items {
          count
          edges {
            listItem {
              item {
                __typename
                ... on ArticleStory {
                  description
                  id
                  label
                  link
                  publisher
                  publishedDate
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  revision
                  subTitle
                  timeToReadInSeconds
                  title
                }
                ... on BookStory {
                  cost
                  description
                  id
                  publisher
                  publishedDate
                  label
                  link
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  subTitle
                  timeToReadInSeconds
                  title
                }
                ... on SearchHit {
                  area
                  country
                  countryCode
                  durationInSeconds
                  landingPageUrl
                  id
                  isPublic
                  kind
                  label
                  linkUrl
                  location
                  name
                  previewUrl
                  published
                  publisher
                  responsibility
                  settlement
                  subTitle
                  tagLine
                  tags
                  title
                }
                ... on NewsletterStory {
                  cost
                  description
                  publisher
                  publishedDate
                  label
                  link
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  subTitle
                  timeToReadInSeconds
                  title
                }
                ... on Entity {
                  description
                  hasPublicPage
                  landingPageUrl
                  id
                  name
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  websiteUrl
                }
                ... on OnlineCourseStory {
                  id
                  cost
                  description
                  label
                  link
                  publisher
                  publishedDate
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  subTitle
                  timeRequiredInSeconds
                  title
                }
                ... on OriginalContentStory {
                  description
                  durationInSeconds
                  id
                  label
                  mediaItem {
                    id
                    label
                  }
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  subTitle
                  title
                }
                ... on Person {
                  description
                  fullName
                  hasPublicPage
                  landingPageUrl
                  id
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  responsibility
                  websiteUrl
                }
                ... on PodcastStory {
                  cost
                  description
                  id
                  publisher
                  publishedDate
                  label
                  link
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        link
                        mediaAsset {
                          id
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                        }
                        kind
                      }
                    }
                  }
                  subTitle
                  title
                }
                ... on Node {
                  id
                }
                ... on Tag {
                  id
                }
              }
              id
            }
          }
        }
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "listID",
    "type": "ID!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listID"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publishedDate",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v14 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v9/*: any*/),
    (v3/*: any*/),
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "path",
      "args": null,
      "storageKey": null
    }
  ]
},
v15 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v16 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v14/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v4/*: any*/)
                  ]
                }
              ]
            },
            (v15/*: any*/)
          ]
        }
      ]
    }
  ]
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "revision",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeToReadInSeconds",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cost",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "area",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "country",
  "args": null,
  "storageKey": null
},
v22 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "countryCode",
  "args": null,
  "storageKey": null
},
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "durationInSeconds",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "isPublic",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkUrl",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "location",
  "args": null,
  "storageKey": null
},
v28 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "previewUrl",
  "args": null,
  "storageKey": null
},
v29 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "published",
  "args": null,
  "storageKey": null
},
v30 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v31 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "settlement",
  "args": null,
  "storageKey": null
},
v32 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tagLine",
  "args": null,
  "storageKey": null
},
v33 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tags",
  "args": null,
  "storageKey": null
},
v34 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPublicPage",
  "args": null,
  "storageKey": null
},
v35 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "websiteUrl",
  "args": null,
  "storageKey": null
},
v36 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "timeRequiredInSeconds",
  "args": null,
  "storageKey": null
},
v37 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "mediaItem",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAsset",
  "plural": false,
  "selections": [
    (v9/*: any*/),
    (v4/*: any*/)
  ]
},
v38 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v39 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v40 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v13/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            (v10/*: any*/),
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v9/*: any*/),
                (v14/*: any*/),
                {
                  "kind": "LinkedField",
                  "alias": null,
                  "name": "topLevelMediaType",
                  "storageKey": null,
                  "args": null,
                  "concreteType": "TopLevelMediaType",
                  "plural": false,
                  "selections": [
                    (v15/*: any*/),
                    (v4/*: any*/),
                    (v9/*: any*/)
                  ]
                }
              ]
            },
            (v15/*: any*/)
          ]
        }
      ]
    }
  ]
},
v41 = [
  (v19/*: any*/),
  (v5/*: any*/),
  (v11/*: any*/),
  (v12/*: any*/),
  (v4/*: any*/),
  (v10/*: any*/),
  (v40/*: any*/),
  (v7/*: any*/),
  (v18/*: any*/),
  (v6/*: any*/)
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "matricesPanelQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "items",
                "storageKey": null,
                "args": null,
                "concreteType": "ListItemsConnection",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "listItem",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItem",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              {
                                "kind": "InlineFragment",
                                "type": "ArticleStory",
                                "selections": [
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "BookStory",
                                "selections": [
                                  (v19/*: any*/),
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "SearchHit",
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v9/*: any*/),
                                  (v25/*: any*/),
                                  (v15/*: any*/),
                                  (v4/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v3/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v11/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v7/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "NewsletterStory",
                                "selections": [
                                  (v19/*: any*/),
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Entity",
                                "selections": [
                                  (v5/*: any*/),
                                  (v34/*: any*/),
                                  (v24/*: any*/),
                                  (v9/*: any*/),
                                  (v3/*: any*/),
                                  (v16/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OnlineCourseStory",
                                "selections": [
                                  (v9/*: any*/),
                                  (v19/*: any*/),
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v16/*: any*/),
                                  (v7/*: any*/),
                                  (v36/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OriginalContentStory",
                                "selections": [
                                  (v5/*: any*/),
                                  (v23/*: any*/),
                                  (v9/*: any*/),
                                  (v4/*: any*/),
                                  (v37/*: any*/),
                                  (v16/*: any*/),
                                  (v7/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Person",
                                "selections": [
                                  (v5/*: any*/),
                                  (v38/*: any*/),
                                  (v34/*: any*/),
                                  (v24/*: any*/),
                                  (v9/*: any*/),
                                  (v16/*: any*/),
                                  (v30/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "PodcastStory",
                                "selections": [
                                  (v19/*: any*/),
                                  (v5/*: any*/),
                                  (v9/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v16/*: any*/),
                                  (v7/*: any*/),
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "matricesPanelQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v39/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "items",
                "storageKey": null,
                "args": null,
                "concreteType": "ListItemsConnection",
                "plural": false,
                "selections": [
                  (v8/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "listItem",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItem",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": null,
                            "plural": false,
                            "selections": [
                              (v39/*: any*/),
                              (v9/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "type": "ArticleStory",
                                "selections": [
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v40/*: any*/),
                                  (v17/*: any*/),
                                  (v7/*: any*/),
                                  (v18/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "BookStory",
                                "selections": (v41/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "SearchHit",
                                "selections": [
                                  (v20/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v25/*: any*/),
                                  (v15/*: any*/),
                                  (v4/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v3/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/),
                                  (v11/*: any*/),
                                  (v30/*: any*/),
                                  (v31/*: any*/),
                                  (v7/*: any*/),
                                  (v32/*: any*/),
                                  (v33/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "NewsletterStory",
                                "selections": (v41/*: any*/)
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Entity",
                                "selections": [
                                  (v5/*: any*/),
                                  (v34/*: any*/),
                                  (v24/*: any*/),
                                  (v3/*: any*/),
                                  (v40/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OnlineCourseStory",
                                "selections": [
                                  (v19/*: any*/),
                                  (v5/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v40/*: any*/),
                                  (v7/*: any*/),
                                  (v36/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "OriginalContentStory",
                                "selections": [
                                  (v5/*: any*/),
                                  (v23/*: any*/),
                                  (v4/*: any*/),
                                  (v37/*: any*/),
                                  (v40/*: any*/),
                                  (v7/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "Person",
                                "selections": [
                                  (v5/*: any*/),
                                  (v38/*: any*/),
                                  (v34/*: any*/),
                                  (v24/*: any*/),
                                  (v40/*: any*/),
                                  (v30/*: any*/),
                                  (v35/*: any*/)
                                ]
                              },
                              {
                                "kind": "InlineFragment",
                                "type": "PodcastStory",
                                "selections": [
                                  (v19/*: any*/),
                                  (v5/*: any*/),
                                  (v11/*: any*/),
                                  (v12/*: any*/),
                                  (v4/*: any*/),
                                  (v10/*: any*/),
                                  (v40/*: any*/),
                                  (v7/*: any*/),
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          },
                          (v9/*: any*/)
                        ]
                      }
                    ]
                  }
                ]
              },
              (v9/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "matricesPanelQuery",
    "id": null,
    "text": "query matricesPanelQuery(\n  $listID: ID!\n) {\n  list(id: $listID) {\n    hasErrors\n    list {\n      __typename\n      ... on List {\n        name\n        label\n        description\n        title\n        subTitle\n        items {\n          count\n          edges {\n            listItem {\n              item {\n                __typename\n                ... on ArticleStory {\n                  description\n                  id\n                  label\n                  link\n                  publisher\n                  publishedDate\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  revision\n                  subTitle\n                  timeToReadInSeconds\n                  title\n                }\n                ... on BookStory {\n                  cost\n                  description\n                  id\n                  publisher\n                  publishedDate\n                  label\n                  link\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  subTitle\n                  timeToReadInSeconds\n                  title\n                }\n                ... on SearchHit {\n                  area\n                  country\n                  countryCode\n                  durationInSeconds\n                  landingPageUrl\n                  id\n                  isPublic\n                  kind\n                  label\n                  linkUrl\n                  location\n                  name\n                  previewUrl\n                  published\n                  publisher\n                  responsibility\n                  settlement\n                  subTitle\n                  tagLine\n                  tags\n                  title\n                }\n                ... on NewsletterStory {\n                  cost\n                  description\n                  publisher\n                  publishedDate\n                  label\n                  link\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  subTitle\n                  timeToReadInSeconds\n                  title\n                }\n                ... on Entity {\n                  description\n                  hasPublicPage\n                  landingPageUrl\n                  id\n                  name\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  websiteUrl\n                }\n                ... on OnlineCourseStory {\n                  id\n                  cost\n                  description\n                  label\n                  link\n                  publisher\n                  publishedDate\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  subTitle\n                  timeRequiredInSeconds\n                  title\n                }\n                ... on OriginalContentStory {\n                  description\n                  durationInSeconds\n                  id\n                  label\n                  mediaItem {\n                    id\n                    label\n                  }\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  subTitle\n                  title\n                }\n                ... on Person {\n                  description\n                  fullName\n                  hasPublicPage\n                  landingPageUrl\n                  id\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  responsibility\n                  websiteUrl\n                }\n                ... on PodcastStory {\n                  cost\n                  description\n                  id\n                  publisher\n                  publishedDate\n                  label\n                  link\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        link\n                        mediaAsset {\n                          id\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                        }\n                        kind\n                      }\n                    }\n                  }\n                  subTitle\n                  title\n                }\n                ... on Node {\n                  id\n                }\n                ... on Tag {\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '03f6a76055a3f312f821c82bc8f98a6d';
export default node;
